import { render, staticRenderFns } from "./ClientNew_Addresses_List.vue?vue&type=template&id=e458ffdc&"
import script from "./ClientNew_Addresses_List.vue?vue&type=script&lang=js&"
export * from "./ClientNew_Addresses_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports